export const calendar = {
  today: 'Today',
  later: 'Later',
  shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  longDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
};
